<template>
    <div class="relative group/media block rounded-xl overflow-hidden shadow-sm cursor-zoom-in">
        <img :src="attachment.url" @click.prevent="$emit('open-lightbox', attachment.url)" class="rounded-xl w-64 h-40 object-cover border border-gray-200/20" />
    </div>
</template>

<script>
export default {
    name: 'ChatPhoto',
    props: {
        attachment: { type: Object, required: true }
    },
    emits: ['open-lightbox']
};
</script>
